export const thdApiMap = (res, paramStoreId) => {
  const arr = [];
  let defaultPipfigFulfillment = [];
  let isDefault = true;
  if (res.data.products) {
    res.data.products.forEach((product) => {
      const fulfillmentData = () => {
        let storeId;
        let isAnchor;
        let quantity;
        let quantityFromVirtual;
        const fulfillmentOption = {};
        const pipfigFulfillment = [];
        const pipfigShipping = {};
        const pricing = {
          alternatePricingDisplay: product.pricing.alternatePriceDisplay,
          dollarOff: product.pricing.promotion?.dollarOff || 0,
          originalPrice: product.pricing.original || product.pricing.value,
          percentageOff: product.pricing.promotion?.percentageOff || 0,
          savingsCenter: product.pricing.promotion?.savingsCenter || 'Special Buys',
          specialPrice: product.pricing.value,
          uom: product.pricing.unitOfMeasure,
        };
        const storeStatus = product.fulfillment.anchorStoreStatus;
        const storeStatusType = product.fulfillment.anchorStoreStatusType;
        if (!product.fulfillment.fulfillmentOptions && product.pricing) {
          pipfigFulfillment.push({
            fulfillmentOptions: null,
            pricing,
            storeId,
            storeStatus,
            storeStatusType,
          });
          isDefault = false;
          return { pipfigFulfillment };
        }
        if (product.fulfillment.fulfillmentOptions) {
          product.fulfillment.fulfillmentOptions.forEach((fulfill) => {
            fulfill.services.forEach((service) => {
              if (service.type !== 'express delivery') {
                const end = `${[service.type]}EstimatedShippingEndDate`;
                const begin = `${[service.type]}EstimatedShippingStartDate`;
                pipfigShipping[end] = service.deliveryDates?.endDate;
                pipfigShipping[begin] = service.deliveryDates?.startDate;
              }
              pipfigShipping.eligibleForFreeShipping = service.hasFreeShipping;
              pipfigShipping.excludedShipStates = product.fulfillment.excludedShipStates;
              pipfigShipping.freeShippingThreshold = service.freeDeliveryThreshold;
              pipfigShipping.isDynamicEta = service.dynamicEta || false;

              service.locations.find((location) => {
                isAnchor = location?.isAnchor;
                if (isAnchor) {
                  quantity = location.inventory?.quantity;
                  storeId = Number(location.locationId);
                }
                if (service.type === 'sth' || service.type === 'boss') {
                  quantityFromVirtual = location.inventory?.quantity;
                }
                return null;
              });
              let statusKey;
              if (service.type === 'boss') {
                statusKey = 'buyOnlineShipToStore';
              } else if (service.type === 'bopis') {
                statusKey = 'buyOnlinePickupInStore';
              } else if (service.type === 'sth') {
                statusKey = 'shipToHome';
              } else if (service.type === 'express delivery') {
                statusKey = 'deliverFromStore';
              }
              fulfillmentOption[statusKey] = { status: true };
              fulfillmentOption.fulfillable = fulfill?.fulfillable;
              if (statusKey === 'deliverFromStore') {
                fulfillmentOption[statusKey].assemblyEligible =
                  product.fulfillment.bodfsAssemblyEligible;
                fulfillmentOption[statusKey].deliveryDateAvailability =
                  service.deliveryTimeline.toUpperCase();
                fulfillmentOption[statusKey].estDeliveryCharge =
                  Number(service?.deliveryCharge) || Number(service?.totalCharge);
              }
            });
          });

          const obj = {
            fulfillmentOptions: fulfillmentOption,
            inventory: {
              expectedQuantityAvailable: quantity,
              onHandQuantity: quantity,
            },
            pricing,
            storeId: storeId || Number(paramStoreId),
            storeStatus,
            storeStatusType,
          };
          pipfigFulfillment.push(obj);
          if (fulfillmentOption.buyOnlineShipToStore || fulfillmentOption.shipToHome) {
            pipfigFulfillment.push({
              fulfillmentOptions: {
                fulfillable: true,
              },
              storeId: 8119,
              inventory: {
                expectedQuantityAvailable: quantityFromVirtual,
                onHandQuantity: quantityFromVirtual,
              },
              storeStatusType: 'ACTIVE',
              storeStatus: true,
              pricing,
            });
          }

          isDefault = false;
          defaultPipfigFulfillment = pipfigFulfillment.map((aaa) => ({ ...aaa }));
          return { pipfigFulfillment, pipfigShipping };
        }
        isDefault = true;
        delete defaultPipfigFulfillment.fulfillmentOptions;
        defaultPipfigFulfillment.forEach((i) => {
          const tempData = i;
          delete tempData.fulfillmentOptions;
          tempData.fulfillmentOptions = { fulfillable: product.availabilityType.status };
        });
        return { defaultPipfigFulfillment };
      };

      const imageUrls = () => {
        const { images, video } = product.media;
        const pipfigMedia = [];
        if (images || video) {
          images.forEach((img) => {
            img.sizes.forEach((size) =>
              pipfigMedia.push({
                height: Number(size),
                width: Number(size),
                location: img.url.replace(/<SIZE>/i, size),
                mediaType: img.type,
              })
            );
          });
          video.forEach((vid) => {
            pipfigMedia.push(JSON.parse(JSON.stringify(vid).replace(/type/i, 'mediaType')));
          });
        }

        return pipfigMedia;
      };

      arr.push({
        defaultSku: Number(product.itemId),
        productId: Number(product.identifiers.parentId) || Number(product.itemId),
        superSku: product.identifiers.isSuperSku,
        skus: {
          sku: {
            itemId: Number(product.itemId),
            itemType: product.identifiers.productType,
            availabilityType: product.availabilityType.type,
            canonicalUrl: product.identifiers.canonicalUrl,
            partNumber: Number(product.identifiers.itemId),
            info: {
              backOrderFlag: product.fulfillment.backordered || null,
              badges: {},
              brandName: product.identifiers.brandName,
              buyOnlinePickupInStoreEligible:
                product.fulfillment.buyOnlinePickupInStoreEligible || false,
              buyOnlineShipToStoreEligible:
                product.fulfillment.buyOnlineShipToStoreEligible || false,
              customExperience: 'custom-storm-doors',
              description: product.details.description,
              modelNumber: Number(product.identifiers.modelNumber),
              omsThdSku: Number(product.identifiers.omsThdSku),
              onlineStatus: product.fulfillment.onlineStoreStatus,
              productClass: Number(product.info.classNumber),
              productDepartment: Number(product.info.productDepartment),
              productLabel: product.identifiers.productLabel,
              productSubClass: Number(product.info.subClassNumber),
              savingsCenter: product.pricing.promotion?.savingsCenter,
            },
            media: {
              mediaEntry: imageUrls(),
            },
            shipping: fulfillmentData().pipfigShipping,
            storeSkus: {
              storeSku: isDefault
                ? fulfillmentData().defaultPipfigFulfillment
                : fulfillmentData().pipfigFulfillment,
            },
          },
        },
      });
    });
  }
  return { products: { product: [...arr] } };
};
